import { useTranslation } from "react-i18next";
import { Button } from "components/button";
import { ErrorPanel } from "components/panels";
import { FirestoreGenerationStatusCode } from "reedy-data/models";
import { generationErrorMessage } from "utils/errors";
import { textVariants } from "components/text";

export const KeywordsError = ({
  statusCode,
  onGenerate,
}: {
  statusCode?: FirestoreGenerationStatusCode | null;
  onGenerate: () => void;
}) => {
  const { t } = useTranslation(["components", "general"]);

  const errorMessage =
    generationErrorMessage(t, statusCode) ||
    t("components:keywordsTab.keywordsError.message", {
      code: statusCode,
    });

  return (
    <ErrorPanel
      title={t("components:keywordsTab.keywordsError.title")}
      errorTitle={t("components:keywordsTab.keywordsError.errorHeader")}
      errorMessage={errorMessage}
      buttons={[
        <Button
          key="generate"
          label={t("general:buttons.retry")}
          onClick={onGenerate}
          icon="sparkles"
          size="small"
          analyticsId="button_regenerate_keywords"
        />,
      ]}
      classes={{
        title: textVariants({ variant: "title" }),
      }}
    />
  );
};
